import React, { useEffect, useState } from 'react';
import PageHeader from '../components/PageHeader';
import { motion } from 'motion/react';
import { History, Target, Eye, Heart } from 'lucide-react';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

const About = () => {
  const [content, setContent] = useState<any>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const docRef = doc(db, 'content', 'pages');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setContent(docSnap.data());
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, []);

  const values = [
    { title: "Missão", desc: content.aboutMission || "Oferecer reabilitação e inclusão social através de atendimentos multidisciplinares de excelência.", icon: Target },
    { title: "Visão", desc: content.aboutVision || "Ser o principal centro de referência em reabilitação física e intelectual do Mato Grosso do Sul.", icon: Eye },
    { title: "Valores", desc: content.aboutValues || "Humanização, ética, compromisso social, transparência e amor ao próximo.", icon: Heart }
  ];

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
    </div>;
  }

  return (
    <main>
      <PageHeader 
        title="Sobre Nós" 
        description="Uma história de dedicação, propósito e transformação social que começou com um pequeno sonho."
      />

      {/* History Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="space-y-8">
              <div className="inline-flex items-center space-x-2 text-primary">
                <History size={24} />
                <span className="font-bold uppercase tracking-widest text-sm">Nossa História</span>
              </div>
              <h2 className="text-4xl font-extrabold text-slate-900 leading-tight">
                Desde 2002, transformando <span className="text-primary">desafios</span> em superação.
              </h2>
              <div className="space-y-4 text-slate-600 text-lg leading-relaxed whitespace-pre-wrap">
                {content.aboutHistoryText || `
                  Fundada em 14 de novembro de 2002 pelo Sr. Lucas Ferrer de Araújo, a UNIFIG nasceu da necessidade de oferecer suporte especializado para pessoas com sequelas neurológicas em Iguatemi.
                  
                  Ao longo de mais de duas décadas, sob a liderança de figuras como o Sr. Cilimar José Cazelli e agora o Sr. Edson Palla, expandimos nossa estrutura para 376m² de área construída totalmente adaptada.
                  
                  Hoje atendemos 105 pacientes, desde bebês até idosos de 87 anos, oferecendo uma gama completa de terapias que garantem qualidade de vida e inclusão.
                `}
              </div>
            </div>
            <div className="relative">
              <img
                src="https://i.postimg.cc/Kv8H0fHP/Whats-App-Image-2026-03-11-at-16-07-14.jpg"
                alt="Nossa História"
                className="rounded-[3rem] shadow-2xl"
                referrerPolicy="no-referrer"
              />
              <div className="absolute -bottom-10 -right-10 bg-primary text-white p-10 rounded-[2rem] shadow-xl hidden md:block">
                <p className="text-5xl font-black mb-1">22+</p>
                <p className="font-bold uppercase tracking-widest text-xs opacity-80">Anos de História</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission, Vision, Values */}
      <section className="py-24 bg-slate-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {values.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="space-y-6 p-10 rounded-[2.5rem] bg-white/5 border border-white/10 hover:bg-white/10 transition-colors"
              >
                <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center text-white shadow-lg shadow-blue-900/20">
                  <item.icon size={32} />
                </div>
                <h3 className="text-2xl font-bold">{item.title}</h3>
                <p className="text-slate-400 leading-relaxed">{item.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default About;
